import { useEffect, useState } from 'react';

import { OrderAttrFilter } from './orderAttrFilter';
import { orderAttrFilterToken } from './orderAttrFilterParams';

/**
 * 表示対象（配送形態・区間種別）の取得用デバウンス時間。
 * チェックを 1 つ動かすたびに 3 クエリ（deliveries・legRuns・allDeliveries）が全ページを
 * 取り直すと、複数外したときに abort されない取得が重なる (issue #317 レビュー I-2)。
 */
export const ORDER_ATTR_FILTER_DEBOUNCE_MS = 400;

/**
 * 最後の操作から ORDER_ATTR_FILTER_DEBOUNCE_MS 経つまで、取得へ渡す値の更新を遅らせる。
 *
 * Why not 画面の表示・クライアント側の絞り込みまで遅らせる: チェックの見た目や
 * 未割当リストの絞り込みが遅れて動くとチラつきに見える。遅らせてよいのは
 * サーバーへの取得だけなので、呼び出し側は不変の orderAttrFilter を Presenter に
 * そのまま渡し、この hook が返すデバウンス後の値だけを 3 クエリへ渡す。
 */
export function useDebouncedOrderAttrFilter(filter: OrderAttrFilter): OrderAttrFilter {
  const [debounced, setDebounced] = useState(filter);
  const token = orderAttrFilterToken(filter);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(filter), ORDER_ATTR_FILTER_DEBOUNCE_MS);
    return () => clearTimeout(timer);
    // Why not [filter]: filter は Set を含むオブジェクトなので、呼び出し元の
    // useMemo が壊れて毎レンダー新しい参照を返すようになった途端、このタイマーが
    // 毎回張り直されて永久に発火しなくなる（絞り込みがサーバーへ届かなくなる）。
    // 値ベースの token に揃えて、中身が変わったときだけ張り直す
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return debounced;
}
